import { defineStore } from 'pinia'
import Axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL ||  window.location.origin + "/"
const RAMO_URL = BASE_URL + "pje/seam/resource/rest/pje-legacy/ApoioIRDR/assunto"
export const useTemaRamoStore = defineStore('temaRamo', {
  state: () => ({ ramos: [], filtered: [] }),
  getters: {
    get: state => state.ramos,
    all: state => state.ramos
  },
  actions: {
    async fetch() {
      const paramsString = `?codigo=${encodeURIComponent("")}&descricao=${encodeURIComponent("")}&raiz=${encodeURIComponent(true)}`;
      const { data } = await Axios.get(RAMO_URL + paramsString)
      this.ramos = Object.entries(data).map(assunto => ({ codigo: assunto[0], descricao: assunto[1] }))
      this.filtered = this.ramos
      return this.ramos
    },
  },
})
